import { Tab, TabBar, TabBarContainer, TabButton, TabButtonBar, TabPanel } from './components';

export const Tabs = {
  Bar: TabBar,
  BarContainer: TabBarContainer,
  Panel: TabPanel,
  Tab,
  Button: TabButton,
  ButtonBar: TabButtonBar,
} as const;
